(() => {
  const FORM_ID = 'GioventoContactForm';
  const MIN_COMPLETION_MS = 1800;
  const WINDOW_MS = 10 * 60 * 1000;
  const MAX_SUBMISSIONS_PER_WINDOW = 3;
  const STORAGE_KEY = 'giovento-contact-submissions';

  const getAttempts = () => {
    try {
      const saved = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '[]');
      const cutoff = Date.now() - WINDOW_MS;
      return Array.isArray(saved) ? saved.filter((time) => Number.isFinite(time) && time > cutoff) : [];
    } catch {
      return [];
    }
  };

  const saveAttempt = (attempts) => {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(attempts));
    } catch {
      // Form submission remains available when browser storage is blocked.
    }
  };

  const showError = (form, message, focusStatus = true) => {
    let status = form.querySelector('[data-gio-contact-client-error]');
    if (!status) {
      status = document.createElement('p');
      status.className = 'gio-contact__form-status gio-contact__form-status--error';
      status.dataset.gioContactClientError = 'true';
      status.setAttribute('role', 'alert');
      status.tabIndex = -1;
      form.prepend(status);
    }
    status.textContent = message;
    if (focusStatus) status.focus();
  };

  const setupContactForm = () => {
    const form = document.getElementById(FORM_ID);
    if (!form || form.dataset.gioProtected === 'true') return;
    form.dataset.gioProtected = 'true';
    const openedAt = Date.now();
    const submitButton = form.querySelector('[type="submit"]');
    const recaptchaNotice = form.querySelector('.gio-contact__recaptcha-notice');
    let firstInvalidField = null;
    let mobileScrollQueued = false;

    if (recaptchaNotice) {
      const closeRecaptchaNotice = () => recaptchaNotice.removeAttribute('open');
      document.addEventListener('click', (event) => {
        if (!recaptchaNotice.contains(event.target)) closeRecaptchaNotice();
      });
      window.addEventListener('scroll', closeRecaptchaNotice, { passive: true });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') closeRecaptchaNotice();
      });
    }

    const fieldContainer = (field) => field.closest('.gio-contact__field, .gio-contact__consent');

    form.addEventListener('invalid', (event) => {
      const field = event.target;
      if (!(field instanceof HTMLInputElement || field instanceof HTMLTextAreaElement || field instanceof HTMLSelectElement)) return;

      field.setAttribute('aria-invalid', 'true');
      fieldContainer(field)?.classList.add('is-invalid');
      if (!firstInvalidField || firstInvalidField.validity.valid) firstInvalidField = field;
      showError(form, 'Bitte fülle die markierten Pflichtfelder aus.', false);

      if (window.matchMedia('(max-width: 749px)').matches && !mobileScrollQueued) {
        mobileScrollQueued = true;
        requestAnimationFrame(() => {
          const target = firstInvalidField;
          const targetContainer = target && fieldContainer(target);
          targetContainer?.scrollIntoView({ behavior: 'smooth', block: 'center' });
          target?.focus({ preventScroll: true });
          mobileScrollQueued = false;
        });
      }
    }, true);

    const clearInvalidState = (event) => {
      const field = event.target;
      if (!(field instanceof HTMLInputElement || field instanceof HTMLTextAreaElement || field instanceof HTMLSelectElement)) return;
      if (!field.validity.valid) return;
      field.removeAttribute('aria-invalid');
      fieldContainer(field)?.classList.remove('is-invalid');
    };
    form.addEventListener('input', clearInvalidState);
    form.addEventListener('change', clearInvalidState);

    window.addEventListener('pageshow', () => {
      form.dataset.gioSubmitting = 'false';
      if (submitButton) {
        submitButton.disabled = false;
        submitButton.removeAttribute('aria-busy');
      }
    });

    form.addEventListener('submit', (event) => {
      if (form.dataset.gioSubmitting === 'true') {
        event.preventDefault();
        return;
      }
      const honeypot = form.querySelector('[name="contact[website]"]');
      const message = form.querySelector('[name="contact[body]"]');
      const attempts = getAttempts();

      if (honeypot?.value.trim()) {
        event.preventDefault();
        return;
      }
      if (Date.now() - openedAt < MIN_COMPLETION_MS) {
        event.preventDefault();
        showError(form, 'Bitte nimm dir einen Moment Zeit und versuche es erneut.');
        return;
      }
      if (!form.checkValidity()) {
        event.preventDefault();
        form.reportValidity();
        return;
      }
      if (!message?.value.trim()) {
        event.preventDefault();
        showError(form, 'Bitte beschreibe kurz dein Anliegen.');
        message?.focus();
        return;
      }
      if (attempts.length >= MAX_SUBMISSIONS_PER_WINDOW) {
        event.preventDefault();
        showError(form, 'Zu viele Anfragen in kurzer Zeit. Bitte versuche es in einigen Minuten erneut.');
        return;
      }

      saveAttempt([...attempts, Date.now()]);
      form.dataset.gioSubmitting = 'true';
      if (submitButton) {
        submitButton.disabled = true;
        submitButton.setAttribute('aria-busy', 'true');
      }
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setupContactForm, { once: true });
  else setupContactForm();
})();
